function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M13.267 10.692h-.804l-.285-.263a6.13 6.13 0 001.597-4.111c0-3.49-2.96-6.318-6.61-6.318C3.514 0 .555 2.828.555 6.318c0 3.49 2.959 6.318 6.61 6.318a6.762 6.762 0 004.301-1.526l.275.272v.768L16.826 17l1.515-1.448-5.075-4.86zm-6.102 0c-2.532 0-4.576-1.954-4.576-4.374s2.044-4.374 4.576-4.374c2.532 0 4.576 1.954 4.576 4.374s-2.044 4.374-4.576 4.374z",
  fill: "#9A9C9F"
});

function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 17,
    fill: "none"
  }, props), _ref);
}

export default __webpack_public_path__ + "dc1e14f03f5582d1c363caa9ec50a73d.svg";
export { SvgSearch as ReactComponent };